import { ReactNode, createContext, useContext, useMemo } from 'react'

interface AssignmentDetailDrawerContextValue {
  /** Workspace that owns the deal/assignment. Empty string disables all detail queries. */
  workspaceId: string
}

const AssignmentDetailDrawerContext = createContext<AssignmentDetailDrawerContextValue | null>(null)

interface ProviderProps {
  workspaceId: string
  children: ReactNode
}

export const AssignmentDetailDrawerContextProvider = ({ workspaceId, children }: ProviderProps) => {
  const value = useMemo<AssignmentDetailDrawerContextValue>(() => ({ workspaceId }), [workspaceId])
  return (
    <AssignmentDetailDrawerContext.Provider value={value}>
      {children}
    </AssignmentDetailDrawerContext.Provider>
  )
}

/** Returns the workspaceId scoped to the assignment detail drawer. Empty string when not yet resolved. */
export const useAssignmentDetailDrawerWorkspaceId = (): string => {
  const ctx = useContext(AssignmentDetailDrawerContext)
  return ctx?.workspaceId ?? ''
}
